export const storage = {
    reports: {
        perpage: 10,
        finder: 'all',
        filterTags: [],
        filterSearch: '',
        filterFrom: null,
        filterTo: null,
        filterType: 'suitable',
    },
    runFinder: {
        abort: false,
    },
    contents: {
        perpage: 10,
        filterTags: [],
        filterSearch: '',
        filterFrom: null,
        filterTo: null,
        filterType: 'full',
        filterReadability: 'unread',
        test: false,
        previewLines: 4,
    },
    autoreply: {
        perpage: 10,
    },
    portfolio: {
        perpage: 10,
    },
    rssTest: {
        fullList: false,
    }
}